import React from "react";
import { type LabelProps, Text } from "react-aria-components";
import { useFieldErrorContext } from "../context.tsx";
import { FieldError } from "./FieldError.tsx";
import { base } from "./InputSubtext.css.ts";
import type { OmittedReactAriaProps } from "./types.ts";

export interface Props extends Omit<LabelProps, OmittedReactAriaProps> {
  /** Helper text displayed below the input field. Shows validation error when field is invalid. */
  text?: string;
  /** Ref to the underlying label element. */
  ref?: React.Ref<HTMLLabelElement>;
}

/**
 * Displays helper text or validation errors below form inputs.
 * Automatically shows FieldError when the field is in an invalid state.
 */
export const InputSubtext: React.FC<Props> = ({ text, ref, ...props }) => {
  const validation = useFieldErrorContext();

  if (validation?.isInvalid === true) {
    return <FieldError />;
  }

  if (text == null) {
    return null;
  }

  return (
    <Text slot="description" className={base} ref={ref} {...props}>
      {text}
    </Text>
  );
};
